export default {"src":"/_next/static/media/kr.fa3a8055.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};